import React from 'react'

export default function ContactSection() {
  return (
    <section className='contact-section'>
    <div className='container'>
        <div className='row'>
            <div className='col-lg-12'>
                <p>Unlock Your Crypto Potential
                </p>
                <h2 className='mb-5'><span>Let's</span> Contact?
                </h2>
                <a className='button-default' href='/get-in-touch'>Make an enquiry</a>
            </div>
        </div>
    </div>
</section>
  )
}
